import { use } from 'react';
import { TextInputGroupContext } from './TextInputGroupContext.ts';

export function useTextInputGroup() {
  return use(TextInputGroupContext);
}
